import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PhaseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PhaseSVG;
